var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-map"},[_c('a',{attrs:{"href":_vm.mapUrl,"target":"_blank"}},[(_vm.staticMapUrl)?_c('img',{attrs:{"src":_vm.staticMapUrl}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }